const appendToUrl = (url, append) => {
  return url.includes('?') ? `${url}&${append}` : `${url}?${append}`;
};

export default appendToUrl;
